import { Spin } from 'antd';
import { createRoot } from 'react-dom/client';
import React, { useEffect, useState } from 'react';
import './Loading.css';

let loadingCount = 0;
let loadingContainer: HTMLDivElement | null = null;
let loadingRoot: any = null;
let showTimeout: NodeJS.Timeout | null = null;
let hideTimeout: NodeJS.Timeout | null = null;

export const Loading = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Chỉ hiển thị loading nếu request mất hơn 300ms
    const timer = setTimeout(() => setVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div className="vf-loading-container">
      <Spin size="large" className="vf-loading-spinner" />
    </div>
  );
};

export const showLoading = () => {
  // Clear các timeout nếu có
  if (showTimeout) {
    clearTimeout(showTimeout);
    showTimeout = null;
  }
  if (hideTimeout) {
    clearTimeout(hideTimeout);
    hideTimeout = null;
  }

  loadingCount++;
  if (loadingCount === 1) {
    // Tạo container nếu chưa tồn tại
    if (!loadingContainer) {
      loadingContainer = document.createElement('div');
      loadingContainer.id = 'loading-container';
      loadingContainer.className = 'vf-loading-container';
      document.body.appendChild(loadingContainer);
      loadingRoot = createRoot(loadingContainer);
    }
    
    // Render loading indicator
    loadingRoot?.render(<Loading />);
  }
};

export const hideLoading = () => {
  loadingCount = Math.max(0, loadingCount - 1);
  if (loadingCount === 0 && loadingContainer && loadingRoot) {
    // Delay unmount để cho phép animation hoàn thành
    hideTimeout = setTimeout(() => {
      if (loadingCount === 0) { // Double check để tránh race condition
        loadingRoot?.unmount();
        // Xóa container khi unmount
        if (loadingContainer) {
          document.body.removeChild(loadingContainer);
          loadingContainer = null;
          loadingRoot = null;
        }
      }
    }, 200);
  }
};

// Cleanup khi component unmount
export const cleanupLoading = () => {
  if (showTimeout) {
    clearTimeout(showTimeout);
    showTimeout = null;
  }
  if (hideTimeout) {
    clearTimeout(hideTimeout);
    hideTimeout = null;
  }

  if (loadingContainer && loadingRoot) {
    loadingRoot.unmount();
    loadingContainer.remove();
    loadingContainer = null;
    loadingRoot = null;
    loadingCount = 0;
  }
};

export const LoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    return () => {
      cleanupLoading();
    };
  }, []);

  return <>{children}</>;
};
